<template>
    <div
        class="l-ss-c-catalog-category-item"
        :class="{
            'l-ss-c-catalog-category-item-active': active,
            'l-ss-c-catalog-category-item-default': !category.id
        }"
        @click="$emit('click', { event: $event, category })"
        @mouseenter="$emit('mouseenter', category)">
        <div
            class="l-ss-c-catalog-category-item-img-wrapper"
            :class="{ 'l-ss-c-catalog-category-item-img-wrapper-custom-img': hasImage }">
            <img
                v-if="hasImage"
                :src="category.image_url"
                @error="onErrorImg">
            <i
                v-else
                v-html="currentIcon">
            </i>
        </div>
        <span
            class="l-ss-c-catalog-category-item-title"
            v-html="category.title"></span>
        <i
            v-html="iconArrowRight"
            v-if="category.child && category.child.length"
            class="l-ss-c-catalog-category-item-icon"></i>
    </div>
</template>

<script>
    import { ref } from '@vue/composition-api';

    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';
    import iconGallery from '@/core/assets/images/icons/gallery.svg';
    import iconSearch from '@/core/assets/images/icons/search-icon.svg';

    export default {
        props: {
            category: {
                type: Object,
                required: true,
            },
            active: {
                type: Boolean,
            },
        },
        setup(props) {
            const { category } = props;

            const hasImage = ref(!!category.image_url);

            const currentIcon = category.id ? iconGallery : iconSearch;

            const onErrorImg = () => {
                hasImage.value = false;
            };

            return {
                iconArrowRight,
                currentIcon,
                hasImage,
                onErrorImg,
            };
        },
    };
</script>

<style scoped>

</style>
